import fetchApi from './api';
import {LoginResponse} from 'models/model';

export const login = async (username: string, password: string): Promise<LoginResponse> => {
    return fetchApi<LoginResponse>('/Authentication/Login', {
        method: 'POST',
        body: JSON.stringify({
            userName: username,
            password: password
        })
    });
};